<template>
  <div class="about-contents-wrapper">
    <Intro textContent="Who<br>We Are" imageFileName="datsu.jpg" imageAlt="魚の鱗" />
    <div class="section-wrapper">
      <WeAre />
      <WeBelieve />
      <HelloIm />
      <ExploreWords />
    </div>
  </div>
</template>

<script>
import Intro from '@/features/common/Intro.vue';
import WeAre from '@/features/about/WeAre.vue';
import WeBelieve from '@/features/about/WeBelieve.vue';
import HelloIm from '@/features/about/HelloIm.vue';
import ExploreWords from '@/features/about/ExploreWords.vue';

export default {
  name: 'AboutUs',
  components: {
    Intro,
    WeAre,
    WeBelieve,
    HelloIm,
    ExploreWords,
  },
};
</script>

<style scoped>
.about-contents-wrapper {
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 100px;
  margin-bottom: 100px;
}

.section-wrapper {
  position: relative;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 10%;
  margin-right: 10%;
  row-gap: 100px;
}

/* タブレット、スマートフォン向けのスタイル */
@media screen and (max-width: 570px) {
  .about-contents-wrapper {
    gap: 80px;
  }

  .section-wrapper {
    width: 80%;
    row-gap: 80px;
  }
}
</style>